import { render, staticRenderFns } from "./tloanapply-add-or-updatee.vue?vue&type=template&id=faa3aa1a&scoped=true&"
import script from "./tloanapply-add-or-updatee.vue?vue&type=script&lang=js&"
export * from "./tloanapply-add-or-updatee.vue?vue&type=script&lang=js&"
import style0 from "./tloanapply-add-or-updatee.vue?vue&type=style&index=0&id=faa3aa1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa3aa1a",
  null
  
)

export default component.exports